import { h, Component, Prop } from '@stencil/core';
import { modalController } from "@ionic/core";

@Component({
  tag: 'tip-meeting-button'
})
export class MeetingButton {
  @Prop() label: string = 'Meeting';

  private async openPopover(e: UIEvent) {
    const options = {
      component: document.createElement('tip-meeting'),
      event: e
    }
    const modal = await modalController.create(options);
    await modal.present();
    return modal;
  }

  render() {
    return (
      <ion-button ion-button
        onClick={(e: UIEvent) => this.openPopover(e)}>
        Meetings
      </ion-button>
    )
  }
}
